import type { Admin, User } from '@gozoki/api-types'

export const isAdmin = (obj: User | Admin | null | undefined): obj is Admin => {
  if (!obj) {
    return false
  }
  return 'adminRights' in obj
}

export const isUser = (obj: User | Admin | null | undefined): obj is User => {
  if (!obj) {
    return false
  }
  return !('adminRights' in obj)
}

export const hasAdminRights = (user: User | Admin | undefined): boolean => {
  if (!user) {
    return false
  }
  return isAdmin(user) && user.adminRights !== 0
}
